import React, { useEffect, useRef, useState } from "react";

export const About = (props) => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  const videoRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          // Load video when section is visible
          if (videoRef.current) {
            videoRef.current.load();
          }
          observer.unobserve(entry.target);
        }
      },
      {
        threshold: 0.2,
        rootMargin: "0px 0px -50px 0px",
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <div id="about" ref={sectionRef}>
      <div className="">
        <div className="" style={{ display:'flex' , width: '100%'}}>
          <div className={`col-xs-12 col-md-6 about-video-container border ${isVisible ? "animate-image" : ""}`}>
            <video
              ref={videoRef}
              className="about-video"
              autoPlay
              muted
              loop
              playsInline
              preload="metadata"
              onLoadStart={() => console.log('About video loading...')}
              onCanPlay={() => console.log('About video ready to play')}
              onError={(e) => console.log('About video error:', e)}
            >
              <source src="img/avhi_goldlow_high_1.webm" type="video/webm" />
              Your browser does not support the video tag.
            </video>
          </div>
          <div className={`col-xs-12 col-md-6 ${isVisible ? "animate-text" : ""}`}>
            <div className="about-text">
              <h2>About AHVI Gold</h2>
              <p>{props.data ? props.data.paragraph : "AHVI Gold is your trusted partner for buying gold at the best market rates. With years of experience in the gold buying industry, we have earned the trust of thousands of customers by providing transparent evaluation, fair pricing, and instant payment. Our certified experts use state-of-the-art equipment to ensure accurate gold assessment."}</p>
              <h3>Our Promise to You</h3>
              <div className="list-style">
                <div className="row">
                  <div className="col-lg-6 col-sm-6 col-xs-12">
                    <ul>
                      {props.data
                        ? props.data.Why.map((d, i) => (
                            <li key={`${d}-${i}`}>
                              <i className="fa fa-check"></i>
                              <span>{d}</span>
                            </li>
                          ))
                        : "loading"}
                    </ul>
                  </div>
                  <div className="col-lg-6 col-sm-6 col-xs-12">
                    <ul>
                      {props.data
                        ? props.data.Why2.map((d, i) => (
                            <li key={`${d}-${i}`}>
                              <i className="fa fa-check"></i>
                              <span>{d}</span>
                            </li>
                          ))
                        : "loading"}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};